import React, { useState } from 'react';
import { Formik, Field, Form } from 'formik';
import { Modal, Button, Col, message, Space, notification } from 'antd';
import { FDatePicker, FFieldLabel } from 'forms/FormikFormItems';
import moment, { Moment } from 'moment';
import { EditPriceListCommand, PriceListDto } from '@services/src/models';
import { getEssityApiClient } from '@services/EssityApi';
import { ajaxCatch } from '@helper/api';
import { IsolatedModal } from '@components/shared/modals/IsolatedModal';

interface IProps {
	visible: boolean;
	onCancel: () => void;
	priceList: PriceListDto;
	onSuccess?: () => void;
}

export const EditPriceListModal: React.FC<IProps> = ({
	visible,
	onCancel,
	priceList,
	onSuccess,
}) => {
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (values: {
		validFrom: Moment;
		validTo?: Moment | null;
	}) => {
		setLoading(true);
		try {
			console.log(priceList.priceListId,
				values.validFrom.toDate(),
				values.validTo ? values.validTo.toDate() : null,)

			const command: EditPriceListCommand = {
				id: priceList.id,
				dateFrom: moment(values.validFrom).utc(true).toDate(),
				dateTo: values.validTo ? moment(values.validTo).utc(true).toDate() : undefined,
			};
			await ajaxCatch(
				() =>
					getEssityApiClient().then((api) =>
						api.price.editPriceList({ body: command })
					),
				() => {
					notification.success({
						placement: 'bottomRight',
						message: 'Price list updated successfully',
					});
					onCancel();
					onSuccess && onSuccess();
				},
				(error) => {
					notification.error({
						placement: 'bottomRight',
						message: 'Failed to update price list',
					});
					console.error(error);
				}
			);
		} finally {
			setLoading(false);
		}
	};

	return (
		<IsolatedModal
			title={`Edit price list - ${priceList.name} (${priceList.priceListId})`}
			visible={visible}
			onCancel={onCancel}
			width="20vw"

		>


			<Formik
				initialValues={{
					validFrom: priceList.validFrom ? moment(priceList.validFrom) : moment(),
					validTo: priceList.validTo ? moment(priceList.validTo) : null,
				}}
				onSubmit={handleSubmit}
			>
				{({ setFieldValue, values }) => (
					<Form>
						<Col>
							<FFieldLabel label="Valid from" />
							<Field
								name="validFrom"
								component={FDatePicker}
								mode="date"
								style={{ width: '80%' }}
							/>
						</Col>
						<Col style={{ marginTop: 20 }}>
							<FFieldLabel label="Valid to" />
							<Field
								name="validTo"
								component={FDatePicker}
								mode="date"
								allowClear={true}
								onChange={(date: Moment | null) => setFieldValue('validTo', date)}
								style={{ width: '80%' }}
							/>
						</Col>
						<Col style={{ textAlign: 'center' }}>
							<Button
								type="primary"
								size="large"

								shape="round"
								htmlType="submit"
								style={{ marginTop: 20 }}
								loading={loading}
								disabled={!values.validFrom}
							>
								Save
							</Button>
						</Col>
					</Form>
				)}
			</Formik>
		</IsolatedModal>
	);
};
